// components/NoLeagueMessage.jsx
import React from 'react';
import styles from './NoLeagueMessage.module.css'; // or adjust to your CSS setup
import { useLeague } from '../utils/LeagueContext';

const NoLeagueMessage = ({ entity = 'data', className }) => {
  const { selectedLeague } = useLeague();
  const noLeagueSelected = !selectedLeague || !selectedLeague._id;

  if (!noLeagueSelected) return null;

  return (
    <div className={styles.noLeagueMessage}>
      <p className={className}>Select a league to see {entity}.</p>
    </div>
  );
};

export default NoLeagueMessage;
